import $ from '../$';
import param from '../functions/param';
import './serializeArray';
$.fn.serialize = function () {
    return param(this.serializeArray());
};
